import { render, staticRenderFns } from "./MobileBanner.vue?vue&type=template&id=70deee76&scoped=true&"
import script from "./MobileBanner.vue?vue&type=script&lang=js&"
export * from "./MobileBanner.vue?vue&type=script&lang=js&"
import style0 from "./MobileBanner.vue?vue&type=style&index=0&id=70deee76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70deee76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70deee76')) {
      api.createRecord('70deee76', component.options)
    } else {
      api.reload('70deee76', component.options)
    }
    module.hot.accept("./MobileBanner.vue?vue&type=template&id=70deee76&scoped=true&", function () {
      api.rerender('70deee76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/MobileBanner.vue"
export default component.exports